import Validator from '../validator';

const isConfirmationCodeLengthValid = string => string?.length === 6;

export default class ConfirmationCodeLengthValidator extends Validator {
  static validate(string) {
    return isConfirmationCodeLengthValid(string);
  }
}
